export default "__VITE_ASSET__BrUWKe9s__"